var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssueCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_84_419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.78125 14.0625C0.351562 14.0625 0 14.4141 0 14.8438V16.4062C0 16.8359 0.351562 17.1875 0.78125 17.1875H6.25V14.0625H0.78125ZM24.6582 5.12695L19.8779 0.341797C19.6582 0.12207 19.3604 0 19.0479 0H18.75V6.25H25V5.95215C25 5.64453 24.8779 5.34668 24.6582 5.12695ZM17.1875 6.64062V0H7.42188C6.77246 0 6.25 0.522461 6.25 1.17188V14.0625H12.5V10.8789C12.5 10.1807 13.3447 9.83398 13.8379 10.3271L18.5059 15.0391C18.8281 15.3662 18.8281 15.8887 18.5059 16.2109L13.833 20.918C13.3398 21.4111 12.4951 21.0645 12.4951 20.3662V17.1875H6.25V23.8281C6.25 24.4775 6.77246 25 7.42188 25H23.8281C24.4775 25 25 24.4775 25 23.8281V7.8125H18.3594C17.7148 7.8125 17.1875 7.28516 17.1875 6.64062Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_84_419",
    x: 0,
    y: -0.5,
    width: 25.5,
    height: 25.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_84_419"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueCertificate);
export default __webpack_public_path__ + "static/media/Issue-certificate.3c905c209b50e257920a4288c4f153c3.svg";
export { ForwardRef as ReactComponent };